import { useMemo } from 'react';
import React, { useEffect, useCallback, useState } from 'react'
import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Backdrop,
  Button,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

type ClientDetails = {
  id: string;
  id_client:string
  id_client_details:string
  name: string;
  etablissement: string;
  identifiant: string;
  nom: string;
  fonction: string;
  email: string;
  telephone: string;
  mobile: string;
  adresse: string;
  codepostal: string;
  ville: string;
  region: string;
  pays: string;
  notes: string;
};





const CardTableClients = (props) => {


  var data: ClientDetails[] = props.dataclientdetails;
  const [openLicences, setOpenLicences] = React.useState(null);
  const [isVisible, setIsVisible] = React.useState('none');
  const [id_client, setId_client] = React.useState(-1);
  

  const columns = useMemo<MRT_ColumnDef<ClientDetails>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Client',
      },
      //column definitions...
      {
        accessorKey: 'etablissement',
        header: 'Etablissement',
      },
      {
        accessorKey: 'identifiant',
        header: 'Identifiant',
      },
      {
        accessorKey: 'nom',
        header: 'Nom du contact',
      },
      {
        accessorKey: 'fonction',
        header: 'Fonction',
      },
      {
        accessorKey: 'email',
        header: 'Courriel',
      },
      {
        accessorKey: 'telephone',
        header: 'Telephone',
      },
      {
        accessorKey: 'mobile',
        header: 'Mobile',
      },
      {
        accessorKey: 'adresse',
        header: 'Adresse',
      },
      {
        accessorKey: 'codepostal',
        header: 'Code postal',
      },
      {
        accessorKey: 'ville',
        header: 'Ville',
      },
      {
        accessorKey: 'region',
        // enableColumnOrdering: false, //disable column ordering for this column,
        header: 'Région',
      },
      {
        accessorKey: 'pays',
        header: 'Pays',
      },
      {
        accessorKey: 'notes',
        header: 'notes',
      },
      {
        accessorKey: 'id_client_details',
        header: 'ID Details',
      },
    ],
    [],
  );
  useEffect(() => {
    console.log(props.dataclientdetails);
  }, [props.dataclientdetails]);

  const openDeleteConfirmModal = (row: MRT_Row<ClientDetails>) => {
   // if (window.confirm('êtes-vous sûr de vouloir effacer le client ' + row.original.name + '?')) {
      console.log(row.original.ID);
      props.handleOpenDelete(props.parent,row.original.ID);
    //}
  };
  const handleSendCnxAutoLogin = (identifiant: string, password: string) => {

    props.handleSendCnxAutoLogin(identifiant, password);
  }
  const handleSendSetClientDetails=async(client)=> {
    var item = {};
    try {
      
      const response = await fetch("/api/public/updateclientdetails", {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(client),
      });
      const users = await response.json();
      item = users;
    } catch (error) { console.log(error); }
    console.log(item);
    return item;
  }
  const handleSaveUser: MRT_TableOptions<ClientDetails>['onEditingRowSave'] = async ({
    values,
    table,
  }) => {
    //const newValidationErrors = validateUser(values);
    /*if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});*/
    //console.log(table.getRow());
    values.id_client=id_client;
    values.ID=values.id_client_details;
    var item=await handleSendSetClientDetails(values);
    if (item.ID!=undefined)
    {
      values.id_client_details=item.ID;
    }
    console.log(values)
    table.setEditingRow(null); //exit editing mode
  };
 
  
  const EditClient=async (row)=>
  {
    setId_client(row.original.ID);
    table.setEditingRow(row);
  }
  const table = useMaterialReactTable({
    columns,
    data,
    enableEditing: true,
    enableColumnPinning: true,
    enableRowActions: true,
    //enableRowSelection: true,
    enableColumnOrdering: true,
    localization: MRT_Localization_FR,
    initialState: { pagination: { pageSize: 30, pageIndex: 0 } ,columnVisibility: { id_client_details:false,pays: false, notes: false, region: false, adresse: false, telephone: false, mobile: false,codepostal:false } },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Editer">
          <IconButton onClick={() => EditClient(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Voir les licences">
          <IconButton onClick={async() => 
            {
              var obj=row;
              row.attente=true
              setOpenLicences(row);
              var licences=await props.getNbLicences(props.parent,row.original.ID);
              //console.log(licences)
              //row.original.licences_all=licences;
              //this.state.licences_all.filter((itf) => itf.type_produit == "pro")
              //<div>Dont licence(s) tuteur totale(s) de Labtice Basic : {this.state.licences_all.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "teacher").length}</div>
              row.attente=false
              //setOpenLicences(null);
              setTimeout((ev)=>setOpenLicences(null),800);
              setTimeout((ev)=>setOpenLicences(row),1000);
            }}>
            <ConfirmationNumberIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Effacer">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    onEditingRowSave: handleSaveUser,
  });

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}><IconButton onClick={() => { if (isVisible == 'none') setIsVisible('block'); else setIsVisible('none'); }}>
        {isVisible == 'none' ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
        <h3 onClick={() => { if (isVisible == 'none') setIsVisible('block'); else setIsVisible('none'); }} style={{ cursor: "pointer" }}>Tableau de tous les clients</h3>
      </div>
      <div style={{ display: isVisible }}>
        <MaterialReactTable table={table} />
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openLicences != null} onClick={(ev) => setOpenLicences(null)}>
          <Container style={{ backgroundColor: '#fff', padding: 30, margin: 10, borderRadius: 6, color: '#444' }} >
            {openLicences != null ?openLicences.attente==false?
              <Box>
                <Box>Licence(s) Labtice Pro Enseignant : {openLicences.original.licences_all.filter((itf) => itf.type_produit == "pro").filter((itf) => itf.type_user == "teacher").length}</Box>
                <Box>Licence(s) Labtice Pro Apprenant : {openLicences.original.licences_all.filter((itf) => itf.type_produit == "pro").filter((itf) => itf.type_user == "student").length}</Box>
                <br/>
                <Box>Licence(s) Labtice Basic Enseignant : {openLicences.original.licences_all.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "teacher").length}</Box>
                <Box>Licence(s) Labtice Basic Apprenant : {openLicences.original.licences_all.filter((itf) => itf.type_produit == "basic").filter((itf) => itf.type_user == "student").length}</Box>
                
              </Box> : <Box>Récupération du détail de toutes les licences. Patientez...</Box>:null}
              {openLicences != null ?openLicences.attente==false?<div style={{ margin: '20px 10px' }}><Button style={{ backgroundColor: '#d0ebef', marginRight: 5 }} onClick={(ev) => { handleSendCnxAutoLogin(openLicences.original.identifiant, openLicences.original.password); setOpenLicences(null); }}>Se connecter</Button><Button style={{ backgroundColor: '#efebd0' }} onClick={(ev) => setOpenLicences(null)}>Fermer</Button></div>:null:null}
          </Container >
        </Backdrop>
      </div>
    </div>);
};

export default CardTableClients;
const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

/*function validateUser(user: ClientDetails) {
  return true
   {
    firstName: !validateRequired(user.firstName)
      ? 'First Name is Required'
      : '',
    lastName: !validateRequired(user.lastName) ? 'Last Name is Required' : '',
    email: !validateEmail(user.email) ? 'Incorrect Email Format' : '',
    true
  };
}*/